/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderItemDto } from './OrderItemDto';
import {
    OrderItemDtoFromJSON,
    OrderItemDtoFromJSONTyped,
    OrderItemDtoToJSON,
    OrderItemDtoToJSONTyped,
} from './OrderItemDto';

/**
 * 
 * @export
 * @interface OrderDto
 */
export interface OrderDto {
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    paymentType?: OrderDtoPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    note?: string;
    /**
     * 
     * @type {Array<OrderItemDto>}
     * @memberof OrderDto
     */
    items?: Array<OrderItemDto>;
}


/**
 * @export
 */
export const OrderDtoPaymentTypeEnum = {
    Cash: 'CASH',
    BankTransfer: 'BANK_TRANSFER'
} as const;
export type OrderDtoPaymentTypeEnum = typeof OrderDtoPaymentTypeEnum[keyof typeof OrderDtoPaymentTypeEnum];


/**
 * Check if a given object implements the OrderDto interface.
 */
export function instanceOfOrderDto(value: object): value is OrderDto {
    return true;
}

export function OrderDtoFromJSON(json: any): OrderDto {
    return OrderDtoFromJSONTyped(json, false);
}

export function OrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'note': json['note'] == null ? undefined : json['note'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(OrderItemDtoFromJSON)),
    };
}

export function OrderDtoToJSON(json: any): OrderDto {
    return OrderDtoToJSONTyped(json, false);
}

export function OrderDtoToJSONTyped(value?: OrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentType': value['paymentType'],
        'note': value['note'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(OrderItemDtoToJSON)),
    };
}

